import { getElementConfig } from "../decorators/index.js";
import { ActionExpression } from "@dooboostore/core";
import { ElementApply, NodeSlot } from "@dooboostore/core-web";
const SWC_NOT_FOUND = Symbol.for("simple-web-component:not-found");
const html = (str, document2) => {
  return [...document2.createRange().createContextualFragment(str).childNodes];
};
const htmlFragment = (html2, doc) => {
  if (!doc) throw new Error("Document is not available");
  const template = doc.createElement("template");
  if (typeof html2 === "string") {
    template.innerHTML = html2.trim();
  } else if (html2 instanceof Node) {
    template.appendChild(html2);
  } else if (Array.isArray(html2)) {
    template.append(...html2);
  }
  return template.content;
};
const textNode = (text, doc) => {
  const d = doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  return d.createTextNode(text !== void 0 && text !== null ? String(text) : "");
};
const commentNode = (comment, doc) => {
  const d = doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  return d.createComment(comment !== void 0 && comment !== null ? String(comment) : "");
};
const createElement = (documentOrWindow, tagName, options) => {
  const doc = "document" in documentOrWindow ? documentOrWindow.document : documentOrWindow;
  if (!doc) throw new Error("Document is not available");
  const el = doc.createElement(tagName);
  if (options?.innerHtml) el.innerHTML = options.innerHtml;
  if (options?.attrs) {
    Object.entries(options.attrs).filter(([k, v]) => v).forEach(([k, v]) => el.setAttribute(k, String(v)));
  }
  if (options?.property) {
    Object.entries(options.property).forEach(([k, v]) => el[k] = v);
  }
  return el;
};
const htmlDivElement = (html2, options) => {
  const d = options?.doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  const el = d.createElement("div");
  el.innerHTML = html2.trim();
  if (options?.attrs) {
    Object.entries(options.attrs).forEach(([k, v]) => el.setAttribute(k, String(v)));
  }
  return el;
};
const htmlSpanElement = (html2, options) => {
  const d = options?.doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  const el = d.createElement("span");
  el.innerHTML = html2.trim();
  if (options?.attrs) {
    Object.entries(options.attrs).forEach(([k, v]) => el.setAttribute(k, String(v)));
  }
  return el;
};
const htmlButtonElement = (html2, options) => {
  const d = options?.doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  const el = d.createElement("button");
  el.innerHTML = html2.trim();
  if (options?.attrs) {
    Object.entries(options.attrs).forEach(([k, v]) => el.setAttribute(k, String(v)));
  }
  return el;
};
const htmlUlElement = (options) => {
  const d = options?.doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  const el = d.createElement("ul");
  if (options?.attrs) {
    Object.entries(options.attrs).forEach(([k, v]) => el.setAttribute(k, String(v)));
  }
  return el;
};
const htmlLiElement = (html2, options) => {
  const d = options?.doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  const el = d.createElement("li");
  el.innerHTML = html2.trim();
  if (options?.attrs) {
    Object.entries(options.attrs).forEach(([k, v]) => el.setAttribute(k, String(v)));
  }
  return el;
};
const htmlAElement = (html2, options) => {
  const d = options?.doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  const el = d.createElement("a");
  el.innerHTML = html2.trim();
  if (options?.href) el.href = options.href;
  if (options?.attrs) {
    Object.entries(options.attrs).forEach(([k, v]) => el.setAttribute(k, String(v)));
  }
  return el;
};
const htmlPElement = (html2, options) => {
  const d = options?.doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  const el = d.createElement("p");
  el.innerHTML = html2.trim();
  if (options?.attrs) {
    Object.entries(options.attrs).forEach(([k, v]) => el.setAttribute(k, String(v)));
  }
  return el;
};
const htmlHeadingElement = (level, html2, options) => {
  const d = options?.doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  const el = d.createElement(`h${level}`);
  el.innerHTML = html2.trim();
  if (options?.attrs) {
    Object.entries(options.attrs).forEach(([k, v]) => el.setAttribute(k, String(v)));
  }
  return el;
};
const htmlSectionElement = (options) => {
  const d = options?.doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  const el = d.createElement("section");
  if (options?.attrs) {
    Object.entries(options.attrs).forEach(([k, v]) => el.setAttribute(k, String(v)));
  }
  return el;
};
const htmlArticleElement = (options) => {
  const d = options?.doc || (typeof document !== "undefined" ? document : void 0);
  if (!d) throw new Error("Document is not available");
  const el = d.createElement("article");
  if (options?.attrs) {
    Object.entries(options.attrs).forEach(([k, v]) => el.setAttribute(k, String(v)));
  }
  return el;
};
var SwcUtils;
((SwcUtils2) => {
  SwcUtils2.getParentContainer = (e) => {
    return e.parentElement ?? e.getRootNode();
  };
  SwcUtils2.parsePathPatternsSetAttributeString = (pathPattern, path) => {
    return JSON.stringify(SwcUtils2.parsePathPatternsSet(pathPattern, path)).replace(/"/g, "'");
  };
  SwcUtils2.parsePathPatternsSet = (pathPattern, urlAndRouter) => {
    urlAndRouter ?? (urlAndRouter = "/");
    const p = typeof urlAndRouter === "string" ? urlAndRouter : urlAndRouter.value.url;
    const searchParams = new URLSearchParams();
    const qs = p.split("?")[1];
    qs?.split("&").forEach((it) => {
      const [k, v] = it.split("=");
      searchParams.set(k, v);
    });
    return {
      path: p,
      searchParams,
      pathData: SwcUtils2.parsePathPatterns(pathPattern, p)
    };
  };
  SwcUtils2.parsePathPatterns = (pathPattern, path) => {
    for (const pattern of pathPattern) {
      const data = SwcUtils2.parsePathPattern(pattern, path || "/");
      if (data !== null) {
        return data;
      }
    }
  };
  SwcUtils2.getHelperSet = (win) => {
    const doc = win.document;
    return {
      $d: doc,
      $w: win,
      $q: (sel, root) => (root ?? doc).querySelector(sel),
      $qa: (sel, root) => Array.from((root ?? doc).querySelectorAll(sel)),
      $qi: (id, root) => (root ?? doc).getElementById(id)
    };
  };
  SwcUtils2.resolveWindow = (el) => {
    const hosts = (0, SwcUtils2.findAllSwcHostsIncludingSelf)(el);
    for (let i = hosts.length - 1; i >= 0; i--) {
      const w = getElementConfig(hosts[i])?.window;
      if (w) return w;
    }
    return typeof window !== "undefined" ? window : void 0;
  };
  SwcUtils2.getHelperAndHostSet = (el, win = (0, SwcUtils2.resolveWindow)(el)) => {
    const helperSet = (0, SwcUtils2.getHelperSet)(win);
    const hostSet = (0, SwcUtils2.getHostSet)(el);
    return {
      ...helperSet,
      ...hostSet,
      $this: el
    };
  };
  SwcUtils2.getValueByPath = (obj, path, rootName) => {
    if (!obj || !path) return SWC_NOT_FOUND;
    const parts = path.split(".");
    let current = obj;
    for (const part of parts) {
      if (current === null || current === void 0) return SWC_NOT_FOUND;
      current = current[part];
    }
    return current;
  };
  SwcUtils2.findNearestSwcAncestorHost = (el) => {
    const el1 = el;
    if (el1.__swc_host) return el1.__swc_host;
    let current = el.parentElement || el.getRootNode?.()?.host;
    const doc = el.ownerDocument;
    const win = doc?.defaultView || (typeof window !== "undefined" ? window : void 0);
    let guard = 0;
    while (current && current !== doc && current !== win) {
      if (++guard > 50) break;
      if (current.__swc_host) return current.__swc_host;
      if (getElementConfig(current)) return current;
      current = current.parentElement || current.getRootNode?.()?.host;
    }
    return void 0;
  };
  SwcUtils2.findAllSwcHostsIncludingSelf = (el) => {
    const hosts = getElementConfig(el) ? [el] : [];
    let current = (0, SwcUtils2.findNearestSwcAncestorHost)(el);
    while (current) {
      hosts.push(current);
      current = (0, SwcUtils2.findNearestSwcAncestorHost)(current);
    }
    return hosts.reverse();
  };
  SwcUtils2.getHosts = (el) => (0, SwcUtils2.findAllSwcHostsIncludingSelf)(el);
  SwcUtils2.getHost = (el) => {
    if (getElementConfig(el)) return el;
    return (0, SwcUtils2.findNearestSwcAncestorHost)(el);
  };
  function projectProcessHtml(id, htmlOrNode, document2) {
    if (typeof htmlOrNode === "string") {
      let t = htmlOrNode;
      t = SwcUtils2.processHtml(id, t, { document: document2, replaceWrap: { start: "<!--[[", end: "]]-->" }, replacer: (id2, script) => NodeSlot.slot(id2, script) });
      t = SwcUtils2.processHtml(id, t, { document: document2, replaceWrap: { start: "<!--[html", end: "]-->" }, replacer: (id2, script) => ElementApply.html(id2, script) });
      t = SwcUtils2.processHtml(id, t, { document: document2, replaceWrap: { start: "<!--[text", end: "]-->" }, replacer: (id2, script) => ElementApply.text(id2, script) });
      t = SwcUtils2.processHtml(id, t, {
        document: document2,
        replaceWrap: { start: /a::\w+=\s*"/, end: /"\s/ },
        replacer: (id2, script, er) => {
          const match = er.expressionStart.match(/^\w+::(\w+)="/);
          const name = match?.[1];
          return ElementApply.attribute(id2, name, script);
        }
      });
      t = SwcUtils2.processHtml(id, t, {
        document: document2,
        replaceWrap: { start: /e::\w+=\s*"/, end: /"\s/ },
        replacer: (id2, script, er) => {
          const match = er.expressionStart.match(/^\w+::(\w+)="/);
          const name = match?.[1];
          return ElementApply.event(id2, name, script);
        }
      });
      t = SwcUtils2.processHtml(id, t, {
        document: document2,
        replaceWrap: { start: /p:\w+=\s*"/, end: /"\s/ },
        replacer: (id2, script, er) => {
          const match = er.expressionStart.match(/^\w+:(\w+)="/);
          const name = match?.[1];
          return ElementApply.property(id2, name, script);
        }
      });
      return t;
    } else if (htmlOrNode) {
      const nodes = Array.isArray(htmlOrNode) ? htmlOrNode : [htmlOrNode];
      const window2 = document2.defaultView;
      nodes.forEach((node) => {
        node.normalize();
        const nodes2 = document2.createTreeWalker(node, window2.NodeFilter.SHOW_ELEMENT | window2.NodeFilter.SHOW_COMMENT);
        const getSlotData = (s) => {
          return s.match(/^\[\[([\s\S]+)\]\]$/)?.[1]?.trim();
        };
        const getHtmlData = (s) => {
          return s.match(/^\[html([\s\S]+)\]$/)?.[1]?.trim();
        };
        const getTextData = (s) => {
          return s.match(/^\[text([\s\S]+)\]$/)?.[1]?.trim();
        };
        while (nodes2.nextNode()) {
          const currentNode = nodes2.currentNode;
          if (currentNode.nodeType === window2.Node.COMMENT_NODE) {
            const targetNode = currentNode;
            const v = targetNode.data.trim();
            const slotData = getSlotData(v);
            const htmlData = getHtmlData(v);
            const textData = getTextData(v);
            if (v && slotData) {
              const res = NodeSlot.slotIds(id, slotData);
              targetNode.data = res.start;
              const end = document2.createComment(res.end);
              targetNode.parentNode?.insertBefore(end, targetNode.nextSibling);
            } else if (v && htmlData) {
              const s = ElementApply.htmlDataSet(id, htmlData);
              targetNode.data = s.start;
              const end = document2.createComment(s.end);
              targetNode.parentNode?.insertBefore(end, targetNode.nextSibling);
            } else if (v && textData) {
              const s = ElementApply.textDataSet(id, textData);
              const end = document2.createComment(s.end);
              targetNode.data = s.start;
              targetNode.parentNode?.insertBefore(end, targetNode.nextSibling);
            }
          } else if (currentNode.nodeType === window2.Node.ELEMENT_NODE) {
            const targetNode = currentNode;
            targetNode.getAttributeNames().forEach((it) => {
              const e = it.match(/e::(\w+)$/);
              const eventName = e?.[1];
              const p = it.match(/p::(\w+)$/);
              const propertyName = p?.[1];
              const a = it.match(/a::(\w+)$/);
              const attributeName = a?.[1];
              const value = targetNode.getAttribute(it);
              if (eventName) {
                targetNode.setAttribute(ElementApply.eventName(id, eventName), value);
                targetNode.removeAttribute(it);
              } else if (propertyName) {
                targetNode.setAttribute(ElementApply.propertyName(id, propertyName), value);
                targetNode.removeAttribute(it);
              } else if (attributeName) {
                targetNode.setAttribute(ElementApply.attributeName(id, attributeName), value);
                targetNode.removeAttribute(it);
              }
            });
          }
        }
      });
      return nodes;
    }
  }
  SwcUtils2.projectProcessHtml = projectProcessHtml;
  function processHtml(id, html2, config) {
    const replaceStart = config.replaceWrap.start;
    const replaceEnd = config.replaceWrap.end;
    const callReturnStart = `${config.replaceWrap.start}=`;
    const callReturnEnd = `${config.replaceWrap.end}`;
    const callStart = `${config.replaceWrap.start}@`;
    const callEnd = `${config.replaceWrap.end}`;
    const hasPattern = (text, start, end) => {
      if (!text) return false;
      const s = text.indexOf(start);
      const e = text.indexOf(end, s + start.length);
      return s !== -1 && e !== -1 && s < e;
    };
    const actionConfig = { expression: { replace: { start: replaceStart, end: replaceEnd }, callReturn: { start: callReturnStart, end: callReturnEnd }, call: { start: callStart, end: callEnd } } };
    const runActionExpression = (source) => {
      const actionExpression = new ActionExpression(source, actionConfig);
      actionExpression.getExpressions().filter((it) => it.type === "replace").forEach((it) => {
        actionExpression.replace(it, config.replacer(id, it.script?.trim(), it));
      });
      return actionExpression.toResult();
    };
    return runActionExpression(html2);
  }
  SwcUtils2.processHtml = processHtml;
  SwcUtils2.getAppHosts = (el) => {
    const hosts = SwcUtils2.findAllAppHostsIncludingSelfDirect(el);
    return hosts;
  };
  SwcUtils2.getAppHost = (el) => {
    const appHosts = (0, SwcUtils2.getAppHosts)(el);
    const appHostsWithoutSelf = appHosts.filter((h) => h !== el);
    return appHostsWithoutSelf.length > 0 ? appHostsWithoutSelf[appHostsWithoutSelf.length - 1] : void 0;
  };
  SwcUtils2.findAppHostIncludingSelfDirect = (el) => {
    const appHosts = (0, SwcUtils2.findAllAppHostsIncludingSelfDirect)(el);
    return appHosts.length > 0 ? appHosts[appHosts.length - 1] : null;
  };
  SwcUtils2.findAllAppHostsIncludingSelfDirect = (el) => {
    const appHosts = [];
    const w = el.ownerDocument?.defaultView || (typeof window !== "undefined" ? window : void 0);
    if (!w) {
      return appHosts;
    }
    let current = el;
    while (current) {
      const isAppHost = current.tagName.toLowerCase() === "swc-app" || current.getAttribute("is")?.startsWith("swc-app-");
      if (isAppHost) {
        appHosts.push(current);
      }
      if (current.parentElement) {
        current = current.parentElement;
      } else {
        const root = current.getRootNode();
        if (w.ShadowRoot && root instanceof w.ShadowRoot) {
          current = root.host;
        } else {
          break;
        }
      }
    }
    return appHosts.reverse();
  };
  SwcUtils2.getHostSet = (el) => {
    const hosts = (0, SwcUtils2.findAllSwcHostsIncludingSelf)(el);
    const ancestors = hosts[hosts.length - 1] === el ? hosts.slice(0, -1) : hosts;
    const $host = ancestors.length > 0 ? ancestors[ancestors.length - 1] : null;
    const $parentHost = ancestors.length > 1 ? ancestors[ancestors.length - 2] : null;
    const $hosts = ancestors;
    const $firstHost = ancestors.length > 0 ? ancestors[0] : null;
    const loopContext = {};
    let curr = el;
    const rootEl = el.ownerDocument?.documentElement;
    while (curr && curr !== rootEl) {
      if (curr.__swc_loop_context) {
        Object.assign(loopContext, curr.__swc_loop_context);
      }
      curr = curr.parentElement || curr.getRootNode().host;
    }
    const $appHosts = SwcUtils2.findAllAppHostsIncludingSelfDirect(el);
    const $appHost = $appHosts.length > 0 ? $appHosts[$appHosts.length - 1] === el ? $appHosts.length > 1 ? $appHosts[$appHosts.length - 2] : null : $appHosts[$appHosts.length - 1] : null;
    const $firstAppHost = $appHosts.length > 0 ? $appHosts[0] : null;
    return {
      $host,
      $parentHost,
      $hosts,
      $firstHost,
      $lastHost: $host,
      // $templateHost: (el as any).__swc_template_host,
      $appHost,
      $appHosts,
      $firstAppHost,
      $lastAppHost: $appHost,
      ...loopContext
    };
  };
  SwcUtils2.parsePathPattern = (pattern, currentPath) => {
    if (pattern === null || pattern === void 0) return {};
    const trimmedPattern = pattern.trim();
    if (trimmedPattern === "" && pattern !== "") return {};
    const paramNames = [];
    const regexPattern = trimmedPattern.replace(/{(\w+)(?::(.+?))?}/g, (match2, paramName, customRegex) => {
      paramNames.push(paramName);
      return `(${customRegex || "[^/]+"})`;
    });
    const regex = new RegExp(`^${regexPattern}$`);
    const match = currentPath.match(regex);
    if (!match) return null;
    const result = {};
    paramNames.forEach((name, index) => {
      result[name] = match[index + 1];
    });
    return result;
  };
  SwcUtils2.parsePathPatternAll = (pattern, currentPath) => {
    if (pattern === null || pattern === void 0) return {};
    const trimmedPattern = pattern.trim();
    if (trimmedPattern === "" && pattern !== "") return {};
    const paramNames = [];
    const regexPattern = trimmedPattern.replace(/{(\w+)(?::(.+?))?}/g, (match2, paramName, customRegex) => {
      paramNames.push(paramName);
      return `(${customRegex || "[^/]+"})`;
    });
    const match = currentPath.match(new RegExp(`^${regexPattern}$`));
    if (!match) return null;
    const result = {};
    paramNames.forEach((name, index) => {
      (result[name] ?? (result[name] = [])).push(match[index + 1]);
    });
    return result;
  };
})(SwcUtils || (SwcUtils = {}));
;
export {
  SWC_NOT_FOUND,
  SwcUtils,
  commentNode,
  createElement,
  html,
  htmlAElement,
  htmlArticleElement,
  htmlButtonElement,
  htmlDivElement,
  htmlFragment,
  htmlHeadingElement,
  htmlLiElement,
  htmlPElement,
  htmlSectionElement,
  htmlSpanElement,
  htmlUlElement,
  textNode
};
//# sourceMappingURL=Utils.js.map
